export const ServiceTypes = {
  ErrorHandler: Symbol('ErrorHandler'),
  ConfigurationService: Symbol('ConfigurationService'),
  AuthenticationService: Symbol('AuthenticationService'),
  ApiService: Symbol('ApiService'),
  SessionManagerService: Symbol('SessionManagerService'),
  SessionManagerServiceExternal: Symbol('SessionManagerServiceExternal'),
  SessionStore: Symbol('SessionStore'),
  ContextualService: Symbol('ContextualService'),
  TaggingService: Symbol('TaggingService'),
  RulesetService: Symbol('RulesetService'),
  TaggingStore: Symbol('TaggingStore'),
  TeamStore: Symbol('TeamStore'),
  LineupStore: Symbol('LineupStore'),
  ContextualDataStore: Symbol('ContextualDataStore'),
  BroadcastConsumerService: Symbol('BroadcastConsumerService'),
  GameReviewStore: Symbol('GameReviewStore'),
  GameReviewService: Symbol('GameReviewService'),
  UiStore: Symbol('UiStore'),
  LogService: Symbol('LogService'),
  HotkeyService: Symbol('HotkeyService'),
  BpTaggingStore: Symbol('BpTaggingStore'),
  MetricStore: Symbol('MetricStore'),
  TaggingSignalRService: Symbol('TaggingSignalRService'),
  ContextStore: Symbol('ContextStore'),
  TrackingContextProvider: Symbol('TrackingContextProvider'),
  IntervalWorkerService: Symbol('IntervalWorkerService'),
  VideoUploadService: Symbol('VideoUploadService'),
  VideoUploaderStateStore: Symbol('VideoUploaderStateStore'),
  FeatureConfigService: Symbol('FeatureConfigService'),
  WizardStore: Symbol('WizardStore'),
  FieldCalibrationStore: Symbol('FieldCalibrationStore'),
  ExtraInningRulesStore: Symbol('ExtraInningRulesStore'),
  ScheduleService: Symbol('ScheduleService'),
  TrackingElementsStore: Symbol('TrackingElementsStore'),
  PitchComService: Symbol('PitchComService'),
  NoteStore: Symbol('NoteStore'),
  NotificationStore: Symbol('NotificationStore'),
};
